import React, { useState, useContext } from "react";
import "./Login.css";
import { Stepper, Step } from "react-form-stepper";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../../firebase.config";
import { Toaster, toast } from "react-hot-toast";
import OTPInput from "otp-input-react";
import { useNavigate } from "react-router-dom";
import clgocde_prici from "../../data/ccode_pno_map.json";
import userContext from "../../context/user-context";
import ClipLoader from "react-spinners/ClipLoader";
import { FiHash, FiLock, FiArrowRight, FiShield, FiCheck } from "react-icons/fi";

export const Login = () => {
	const { setuserclgcode, setCname } = useContext(userContext);

	const navigate = useNavigate();

	var clgname = "";

	const [stage1loader, setStage1loader] = useState(false);
	const [clgcode, setClgcode] = useState("");
	const [stepnumber, setstepnumber] = useState(0);
	const [priciphone, setPriciphone] = useState("");
	const [otp, setOtp] = useState();
	const [priciname, setPriciname] = useState("");
	const [password, setPassword] = useState("");

	const configureCaptchaVerify = () => {
		window.recaptchaVerifier = new RecaptchaVerifier(
			"sign-in-button",
			{
				size: "invisible",
				callback: (response) => {
					// reCAPTCHA solved, allow signInWithPhoneNumber.
					onSignInSubmit();
					console.log("Recaptcha verified");
				},
				defaultCountry: "IN"
			},
			auth
		);
	};

	const onSignInSubmit = (e) => {
		e.preventDefault();
		if (clgcode == "") {
			toast.error("Enter College Code");
			return;
		}

		var reqclg = clgocde_prici.find((clg) => clg.ccode.toString() == clgcode);
		if (reqclg == null || reqclg == undefined) {
			toast.error("College Code Doesnt exit");
			return;
		}
		setStage1loader(true);
		var phoneno = reqclg.pno.toString();
		var pname = reqclg.pname;
		configureCaptchaVerify();
		const phoneNumber = "+91" + phoneno;
		setPriciphone(phoneNumber);
		setPriciname(pname);
		console.log(phoneNumber);
		const appVerifier = window.recaptchaVerifier;
		signInWithPhoneNumber(auth, phoneNumber, appVerifier)
			.then((confirmationResult) => {
				// SMS sent. Prompt user to type the code from the message, then sign the
				// user in with confirmationResult.confirm(code).
				window.confirmationResult = confirmationResult;
				toast.success("OTP has been sent");
				console.log("OTP has been sent");
				setstepnumber(1);
				// ...
			})
			.catch((error) => {
				// Error; SMS not sent
				// ...
				toast.error("Too many login requests, Try after 1 hour");
				console.log(error);
				console.log("SMS not sent");
			});
	};

	const onSubmitOTP = (e) => {
		e.preventDefault();
		const code = otp;
		console.log(code);
		window.confirmationResult
			.confirm(code)
			.then((result) => {
				// User signed in successfully.
				const user = result.user;
				console.log(JSON.stringify(user));
				setuserclgcode(clgcode);
				navigate("/table");
				// ...
			})
			.catch((error) => {
				console.log(JSON.stringify(error));
				if (error) {
					toast.error("Invalid OTP");
				}

				// User couldn't sign in (bad verification code?)
				// ...
			});
	};

	const handleLogin = () => {
		if (
			password ===
			clgocde_prici.find((data) => data.ccode === parseInt(clgcode)).Password
		) {
			setuserclgcode(clgcode);
			navigate("/table");
		} else {
			toast.error("Invalid Password");
		}
	};

	return (
		<div className="auth">
			<Toaster
				toastOptions={{
					style: {
						background: "#ffffff",
						color: "#2c2722",
						border: "1px solid #ece3d4",
						boxShadow: "0 12px 30px -14px rgba(54,45,36,0.28)",
						fontFamily: "'IBM Plex Sans', sans-serif"
					}
				}}
			/>
			<div id="sign-in-button"></div>

			<div className="auth-grid">
				<aside className="auth-aside">
					<span className="auth-eyebrow">
						<span className="ping" /> Government of Tamil Nadu
					</span>
					<h1 className="auth-headline">
						<span className="grad">TNGASA</span>
						<br />
						College admissions
					</h1>
					<p className="auth-desc">
						The TNGASA Command Center gives your institution a single, secure
						window into allotted candidates — ranked, filtered and export-ready
						across every annexure category.
					</p>
					<ul className="auth-features">
						<li>
							<span className="ftick">
								<FiCheck />
							</span>
							Branch-wise ranked candidate lists in real time
						</li>
						<li>
							<span className="ftick">
								<FiCheck />
							</span>
							One-click annexure exports — Sports, NCC, DAP &amp; more
						</li>
						<li>
							<span className="ftick">
								<FiCheck />
							</span>
							Encrypted, principal-verified institutional access
						</li>
					</ul>
				</aside>

				<section className="auth-card">
					<span className="auth-badge">
						<FiShield /> Institution Login
					</span>
					<h2>Welcome back</h2>
					<p className="auth-card-sub">
						Sign in with your college code and portal password.
					</p>

					<div className="steppercont">
						<Stepper
							activeStep={stepnumber}
							styleConfig={{
								activeBgColor: "#b5673b",
								completedBgColor: "#7c8a4e",
								inactiveBgColor: "#f6efe4",
								activeTextColor: "#ffffff",
								completedTextColor: "#ffffff",
								inactiveTextColor: "#9a9082",
								size: 30,
								labelFontSize: "12px"
							}}
						>
							<Step label="College Code" />
							<Step label="Authenticate" />
						</Stepper>
					</div>

					{stepnumber == 0 && (
						<div className="auth-fields">
							<div className="auth-field">
								<label>College Code</label>
								<div className="auth-input is-code">
									<FiHash />
									<input
										onChange={(e) => setClgcode(e.target.value)}
										type="text"
										placeholder="e.g. 1234"
									/>
								</div>
							</div>

							<div className="auth-field">
								<label>Password</label>
								<div className="auth-input">
									<FiLock />
									<input
										onChange={(e) => setPassword(e.target.value)}
										type="password"
										placeholder="Enter your password"
										onKeyDown={(e) => {
											if (e.key === "Enter") handleLogin();
										}}
									/>
								</div>
							</div>

							<button className="auth-submit" onClick={handleLogin}>
								Enter Portal <FiArrowRight />
							</button>
						</div>
					)}

					<div className="auth-foot">
						<FiShield />
						Connection secured · Access restricted to authorised institutions
					</div>
				</section>
			</div>
		</div>
	);
};
